<div
  class="dropdown"
  (document:click)="blur()"
  [class.is-active]="isActive"
  [class.is-right]="isRightAligned"
  [class.is-hoverable]="isHoverable"
  (click)="toggle($event)"
>
  <div class="dropdown-trigger">
    <button
      class="button"
      [class.is-small]="isSmall"
      aria-haspopup="true"
      aria-controls="dropdown-menu"
    >
      <ng-content select="[header]" />
    </button>
  </div>
  <div class="dropdown-menu" id="dropdown-menu" role="menu">
    <div class="dropdown-content">
      <ng-content select="[items]" />
    </div>
  </div>
</div>
